import { Box, Flex, Grid, media, Stack, xcss } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';

export const LoadingSkeleton = () => {
	return (
		<Grid alignItems="center" xcss={responsiveStyles}>
			<Box />
			<Flex alignItems="center" justifyContent="center">
				<Box xcss={skeletonItemsContainer}>
					<Stack space="space.500">
						<Skeleton width="100%" height="300px" isShimmering borderRadius="6px" />
						<Skeleton width="100%" height="150px" isShimmering borderRadius="6px" />
						<Skeleton width="100%" height="150px" isShimmering borderRadius="6px" />
						<Skeleton width="100%" height="200px" isShimmering borderRadius="6px" />
						<Skeleton width="100%" height="200px" isShimmering borderRadius="6px" />
					</Stack>
				</Box>
			</Flex>
			<Box />
		</Grid>
	);
};

const skeletonItemsContainer = xcss({
	paddingTop: 'space.500',
	paddingBottom: 'space.300',
	paddingLeft: 'space.300',
	paddingRight: 'space.300',
	width: '100%',
});

const responsiveStyles = xcss({
	[media.above.lg]: {
		width: '1200px',
	},
	marginLeft: 'auto',
	marginRight: 'auto',
});
